// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================================================
   Margin trading page — leverage trigger + Adjust Leverage modal
   (Loaded from margin/index.js; scoped with .agce-margin- prefix.)
   ============================================================================= */

.agce-margin-leverage-row {
  padding: 0px;
  border-bottom: none;
}

/* body.light_theme .agce-margin-leverage-row {
  border-bottom-color: rgba(15, 23, 42, 0.08);
} */

.agce-margin-leverage-trigger {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  max-width: 100%;
  justify-content: start;
  padding: 2px 0px 8px;
  border-radius: 0px;
  border: none;
  background: none;
  color: #e2e8f0;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}

/* .agce-margin-leverage-trigger:hover {
  background: rgba(255, 255, 255, 0.07);
  border-color: rgba(255, 255, 255, 0.16);
} */

.agce-margin-leverage-trigger {
  border-color: transparent;
  background: none;
  color: #0f172a;
}


.agce-margin-leverage-label {
  color: #94a3b8;
  font-weight: 500;
}

.agce-margin-leverage-label {
  color: #64748b;
}

.agce-margin-leverage-value {
  color: #f8fafc;
  font-weight: 600;
}

.agce-margin-leverage-value {
  color: #0f172a;
}

.agce-margin-leverage-trigger i {
  font-size: 18px;
  opacity: 0.85;
  margin-left: 2px;
}

/* Spot / Cross / Isolated / ETF / Futures — single row + horizontal scroll when narrow */
.agce-margin-surface-tabs-outer {
  min-width: 0;
}

.agce-margin-surface-tabs-scroll-wrap {
  min-width: 0;
  flex: 1 1 auto;
}

.agce-margin-surface-tabs-scroller {
  min-width: 0;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}

.agce-margin-surface-tabs-scroller::-webkit-scrollbar {
  display: none;
}

.margin-surface-tabs .margin_surface_tab_strip>button {
  flex-shrink: 0;
}

.agce-margin-surface-tab-scroll-btn {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #94a3b8;
  cursor: pointer;
  transition: color 0.15s ease, background 0.15s ease, opacity 0.15s ease;
}

.agce-margin-surface-tab-scroll-btn:hover:not(:disabled) {
  color: #e2e8f0;
  background: rgba(255, 255, 255, 0.08);
}

.agce-margin-surface-tab-scroll-btn:disabled {
  opacity: 0.28;
  cursor: default;
  pointer-events: none;
}

body.light_theme .agce-margin-surface-tab-scroll-btn {
  color: #84888c;
}

body.light_theme .agce-margin-surface-tab-scroll-btn:hover:not(:disabled) {
  color: #0f172a;
  background: rgba(15, 23, 42, 0.06);
}

/* ——— Modal ——— */
.agce-margin-lvg-modal-root {
  position: fixed;
  inset: 0;
  z-index: 10600;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px;
  z-index: 99999999;
}

.agce-margin-lvg-modal-backdrop {
  position: absolute;
  inset: 0;
  background: rgb(255 255 255 / 20%);
  -webkit-backdrop-filter: blur(5px);
          backdrop-filter: blur(5px);
}

.agce-margin-lvg-modal-panel {
  position: relative;
  width: 100%;
  max-width: 540px;
  border-radius: 14px;
  background: rgb(255 255 255 / 20%);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  color: #0f172a;
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.28);
  font-family: "Inter", sans-serif;
  overflow: hidden;
}

.agce-margin-lvg-modal-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 18px 12px;
  border-bottom: 1px solid #e2e8f0;
}

.agce-margin-lvg-modal-title {
  margin: 0;
  font-size: 17px;
  font-weight: 700;
}

.agce-margin-lvg-modal-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 10px;
  background: transparent;
  color: #64748b;
  cursor: pointer;
}

.agce-margin-lvg-modal-close:hover {
  background: #f1f5f9;
  color: #0f172a;
}

.agce-margin-lvg-modal-body {
  padding: 16px 18px 8px;
}

.agce-margin-lvg-field-label {
  display: block;
  font-size: 12px;
  font-weight: 500;
  color: #64748b;
  margin-bottom: 6px;
}

.agce-margin-lvg-coin-row {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 18px;
}

.agce-margin-lvg-coin-row img {
  width: 24px;
  height: 24px;
  border-radius: 50%;
}

.agce-margin-lvg-input-wrap {
  position: relative;
  margin-bottom: 12px;
}

.agce-margin-lvg-input {
  width: 100%;
  padding: 12px 40px 12px 12px;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 800;
  outline: none;
}

.agce-margin-lvg-input:focus {
  border-color: #0f172a;
  box-shadow: 0 0 0 2px rgba(15, 23, 42, 0.08);
}

.agce-margin-lvg-stepper {
  position: absolute;
  right: 6px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.agce-margin-lvg-stepper button {
  width: 22px;
  height: 12px;
  border: none;
  background: none;
  border-radius: 4px;
  font-size: 10px;
  line-height: 1;
  cursor: pointer;
  padding: 0;
}

/* .agce-margin-lvg-stepper button:hover {
  background: #e2e8f0;
} */

.agce-margin-lvg-quick {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 18px;
}

.agce-margin-lvg-quick button {
  min-width: 52px;
  padding: 8px 6px;
  border-radius: 999px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  font-size: 13px;
  font-weight: 600;
  color: #334155;
  cursor: pointer;
}

.agce-margin-lvg-quick button:hover {
  background: #e2e8f0;
}

.agce-margin-lvg-quick button.is-active {
  border-color: #0f172a;
  background: #fff;
  color: #0f172a;
}

.agce-margin-lvg-stats {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 12px;
}

.agce-margin-lvg-stat {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
}

.agce-margin-lvg-stat dt {
  margin: 0;
  color: #64748b;
  font-weight: 500;
}

.agce-margin-lvg-stat dd {
  margin: 0;
  font-weight: 600;
  color: #0f172a;
  display: flex;
  align-items: center;
  gap: 4px;
}

.agce-margin-lvg-warn {
  font-size: 12px;
  line-height: 1.45;
  color: #ea580c;
  margin: 0 0 8px;
}

.agce-margin-lvg-modal-body .agce-margin-lvg-defaults {
  margin-top: 8px;
  margin-bottom: 0;
}

.agce-margin-lvg-modal-foot {
  display: flex;
  gap: 10px;
  padding: 14px 18px 18px;
}

.agce-margin-lvg-btn {
  flex: 1 1;
  padding: 12px 14px;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  border: none;
  cursor: pointer;
}

.agce-margin-lvg-btn--ghost {
  background: #f1f5f9;
  color: #0f172a;
}

.agce-margin-lvg-btn--ghost:hover {
  background: #e2e8f0;
}

.agce-margin-lvg-btn--primary {
  background: #d1aa67;
  color: #14161a;
}

.agce-margin-lvg-btn--primary:hover {
  filter: brightness(1.05);
  background: #d1aa67;
}

/* Foot layout + primary — higher specificity so shared margin/*.css cannot reset flex / white Confirm */
.agce-margin-lvg-modal-foot .agce-margin-lvg-btn--ghost {
  flex: 0.65 1;
  max-width: 34%;
}

.agce-margin-lvg-modal-foot .agce-margin-lvg-btn--primary {
  flex: 2.1 1;
  background: #d1aa67 !important;
  color: #14161a !important;
}

.agce-margin-lvg-modal-foot .agce-margin-lvg-btn--primary:hover {
  filter: brightness(1.05);
  background: #d1aa67 !important;
}

/* ——— Advanced Limit — Order Type modal ——— */
.agce-margin-ordty-modal-root {
  position: fixed;
  inset: 0;
  z-index: 9999999999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px;
}

.agce-margin-ordty-modal-backdrop {
  position: absolute;
  inset: 0;
  background: rgb(255 255 255 / 20%);
  -webkit-backdrop-filter: blur(5px);
          backdrop-filter: blur(5px);
}

.agce-margin-ordty-modal-panel {
  position: relative;
  width: 100%;
  max-width: 440px;
  max-height: min(92vh, 640px);
  display: flex;
  flex-direction: column;
  border-radius: 14px;
  background: #ffffff;
  color: #0f172a;
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.28);
  font-family: "Inter", sans-serif;
  overflow: hidden;
}

.agce-margin-ordty-modal-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  padding: 16px 18px 12px;
  border-bottom: 1px solid #e2e8f0;
}

.agce-margin-ordty-modal-title {
  margin: 0;
  font-size: 17px;
  font-weight: 700;
}

.agce-margin-ordty-modal-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 10px;
  background: transparent;
  color: #64748b;
  cursor: pointer;
}

.agce-margin-ordty-modal-close:hover {
  background: #f1f5f9;
  color: #0f172a;
}

.agce-margin-ordty-modal-body {
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 14px 18px 8px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.agce-margin-ordty-option {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  width: 100%;
  margin: 0;
  padding: 12px 14px;
  text-align: left;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background: #fff;
  cursor: pointer;
  font-family: "Inter", sans-serif;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.agce-margin-ordty-option:hover {
  border-color: #cbd5e1;
}

.agce-margin-ordty-option.is-selected {
  border-width: 1px;
  border-color: #c6c6c6;
  padding: 11px 13px;
  box-shadow: 0 0 0 1px rgba(15, 23, 42, 0.06);
}

.agce-margin-ordty-option-title {
  font-size: 15px;
  font-weight: 600;
  color: #0f172a;
}

.agce-margin-ordty-option-desc {
  font-size: 13px;
  line-height: 1.45;
  font-weight: 500;
  color: #64748b;
}

.agce-margin-ordty-modal-foot {
  flex-shrink: 0;
  padding: 14px 18px 18px;
}

.agce-margin-ordty-btn-confirm {
  width: 100%;
  padding: 14px 16px;
  border-radius: 10px;
  border: none;
  background: #0f172a;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  font-family: "Inter", sans-serif;
  cursor: pointer;
}

.agce-margin-ordty-btn-confirm:hover {
  background: #1e293b;
}

@media (max-width: 991px) {
  .agce-margin-leverage-row {
    padding-left: 8px;
    padding-right: 8px;
  }
}

/* TP/SL — one Market/Limit toggle; same fill + radius as .trade_price_field (trade_new.css) */
.agce-margin-tp-sl-price-row {
  flex-wrap: nowrap;
}

.agce-margin-tp-sl-toggle-btn {
  flex-shrink: 0;
  align-self: stretch;
  min-width: 72px;
  height: 40px;
  margin: 0;
  padding: 0 14px;
  box-sizing: border-box;
  border: none;
  border-radius: 8px;
  background: #f6f6f7;
  color: #070808;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  font-family: "Inter", sans-serif;
  transition: background 0.15s ease, box-shadow 0.15s ease;
}

.agce-margin-tp-sl-toggle-btn:hover {
  background: #ececed;
}

.agce-margin-tp-sl-toggle-btn:focus-visible {
  outline: none;
  box-shadow: 0 0 0 1px rgba(30, 144, 255, 0.45);
}

body.light_theme .agce-margin-tp-sl-toggle-btn {
  background: #f6f6f7;
  color: #070808;
}

body.light_theme .agce-margin-tp-sl-toggle-btn:hover {
  background: #ececed;
}

/* Conditional — Order Price: strong border when execution is Market (matches mobile ref). */
.margin-advanced-block--cond .agce-margin-tp-sl-toggle-btn[aria-pressed="false"] {
  background: #f5f5f5;
  font-weight: 500;
}

.margin-advanced-block--cond .agce-margin-tp-sl-toggle-btn[aria-pressed="true"] {
  border: 1px solid #e2e8f0;
}

/* TP/SL + TWAP + Iceberg — extra breathing room for quote/base suffix (USDT, BTC) inside filled rows */
.margin-advanced-block--tp-sl .trade_price_suffix,
.margin-advanced-block--twap .trade_price_suffix,
.margin-advanced-block--iceberg .trade_price_suffix,
.margin-advanced-block--loop .trade_price_suffix,
.margin-advanced-block--trail .trade_price_suffix,
.margin-advanced-block--adv-lim .trade_price_suffix,
.margin-advanced-block--cond .trade_price_suffix {
  padding-left: 10px;
  padding-right: 14px;
}

.margin-advanced-block--tp-sl .trade_amount_field_limit>.input-group-text.trade_amount_coin_badge,
.margin-advanced-block--tp-sl .trade_amount_field_limit>.input-group-text,
.margin-advanced-block--twap .trade_amount_field_limit>.input-group-text.trade_amount_coin_badge,
.margin-advanced-block--twap .trade_amount_field_limit>.input-group-text,
.margin-advanced-block--iceberg .trade_amount_field_limit>.input-group-text.trade_amount_coin_badge,
.margin-advanced-block--iceberg .trade_amount_field_limit>.input-group-text,
.margin-advanced-block--loop .trade_amount_field_limit>.input-group-text.trade_amount_coin_badge,
.margin-advanced-block--loop .trade_amount_field_limit>.input-group-text,
.margin-advanced-block--trail .trade_amount_field_limit>.input-group-text.trade_amount_coin_badge,
.margin-advanced-block--trail .trade_amount_field_limit>.input-group-text,
.margin-advanced-block--adv-lim .trade_amount_field_limit>.input-group-text.trade_amount_coin_badge,
.margin-advanced-block--adv-lim .trade_amount_field_limit>.input-group-text,
.margin-advanced-block--cond .trade_amount_field_limit>.input-group-text.trade_amount_coin_badge,
.margin-advanced-block--cond .trade_amount_field_limit>.input-group-text {
  padding-left: 10px !important;
  padding-right: 14px !important;
  min-width: 3.25rem;
  justify-content: center;
}

/* Loop Order — price row (optional + quote | mode), Valid for row, dropdown menus */
.trade_price_field.agce-margin-loop-price-row {
  position: relative;
  align-items: center;
  padding-right: 4px;
}

.agce-margin-loop-price-quote {
  flex-shrink: 0;
  font-size: 13px;
  font-weight: 600;
  color: #070808;
  padding-right: 2px;
}

.agce-margin-loop-price-bar {
  flex-shrink: 0;
  padding: 0 6px;
  font-size: 14px;
  font-weight: 500;
  color: #c3c6c8;
  -webkit-user-select: none;
          user-select: none;
}

.agce-margin-loop-price-mode {
  position: relative;
  flex-shrink: 0;
  display: flex;
  align-items: stretch;
  align-self: stretch;
  margin-left: 4px;
  padding-left: 6px;
  border-left: 1px solid #dfe0e2;
}

.agce-margin-loop-price-mode-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin: 0;
  padding: 0 8px 0 4px;
  border: 0;
  background: transparent;
  font-family: "Inter", sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #070808;
  cursor: pointer;
  white-space: nowrap;
  outline: none;
}

.agce-margin-loop-price-mode-btn:focus-visible {
  box-shadow: none;
}

.agce-margin-loop-price-mode-chev {
  font-size: 18px;
  color: #64748b;
  line-height: 1;
  margin-left: 2px;
}

.agce-margin-loop-price-row.is-open .agce-margin-loop-price-mode-chev,
.agce-margin-loop-valid-wrap.is-open .agce-margin-loop-valid-chev {
  color: #475569;
}

.trade_price_field.agce-margin-loop-valid-wrap {
  position: relative;
  padding: 0;
}

.agce-margin-loop-valid-btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 40px;
  margin: 0;
  padding: 0 12px 0 12px;
  border: 0;
  background: transparent;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #070808;
  text-align: left;
  cursor: pointer;
  outline: none;
}

.agce-margin-loop-valid-btn:focus-visible {
  box-shadow: none;
}

.agce-margin-loop-valid-btn__text {
  flex: 1 1 auto;
  min-width: 0;
}

.agce-margin-loop-valid-chev {
  font-size: 18px;
  color: #64748b;
  line-height: 1;
  flex-shrink: 0;
  margin-left: 8px;
}

.agce-margin-loop-price-mode .agce-margin-loop-pick__menu {
  left: auto;
  right: 0;
  min-width: 11rem;
}

.agce-margin-loop-valid-wrap .agce-margin-loop-pick__menu {
  left: 0;
  right: 0;
}

.agce-margin-loop-pick__menu {
  position: absolute;
  top: calc(100% + 4px);
  z-index: 30;
  list-style: none;
  margin: 0;
  padding: 4px 0;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.12);
  max-height: 240px;
  overflow-y: auto;
}

.agce-margin-loop-pick__menu-item {
  margin: 0;
  padding: 0;
}

.agce-margin-loop-pick__option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  margin: 0;
  padding: 6px 14px;
  border: none;
  background: transparent;
  text-align: left;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-weight: 400;
  color: #0f172a;
  cursor: pointer;
}

.agce-margin-loop-pick__option:hover {
  background: #f1f5f9;
}

.agce-margin-loop-pick__check {
  flex-shrink: 0;
  font-size: 18px;
  color: #1e90ff;
  line-height: 1;
}

.agce-margin-loop-pick__check-slot {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
}

/* Trailing Stop — pullback: filled row + %|USDT unit menu + 5% chip */
.agce-margin-trail-pullback-row {
  display: flex;
  align-items: stretch;
  gap: 8px;
  width: 100%;
}

.agce-margin-trail-pullback-field.trade_price_field {
  flex: 1 1 auto;
  min-width: 0;
}

.agce-margin-trail-preset-chip {
  flex-shrink: 0;
  min-width: 52px;
  margin: 0;
  padding: 0 12px;
  box-sizing: border-box;
  height: 40px;
  align-self: stretch;
  border: none;
  border-radius: 8px;
  background: #f6f6f7;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #070808;
  cursor: pointer;
  transition: background 0.15s ease;
}

.agce-margin-trail-preset-chip:hover {
  background: #ececed;
}

.agce-margin-trail-preset-chip:focus-visible {
  outline: none;
  box-shadow: 0 0 0 1px rgba(30, 144, 255, 0.45);
}

.agce-margin-twap-interval-unit-wrap.agce-margin-trail-pull-unit .agce-margin-loop-pick__menu {
  left: auto;
  right: 0;
  min-width: 8rem;
}

.agce-margin-iceberg-section-title {
  margin: 0 0 10px 2px;
  padding: 0;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #1f1f1f;
}

/* TWAP — duration split (H | M), presets, advanced toggle, inline selects */
.agce-margin-twap-duration-shell {
  display: flex;
  align-items: stretch;
  flex-wrap: nowrap;
  width: 100%;
  min-height: 40px;
  box-sizing: border-box;
  background: #f6f6f7;
  border-radius: 8px;
  overflow: hidden;
  font-family: "Inter", sans-serif;
}

.agce-margin-twap-duration-cell {
  flex: 1 1 50%;
  display: flex;
  align-items: center;
  min-width: 0;
  padding: 0 4px 0 12px;
}

.agce-margin-twap-duration-input {
  flex: 1 1 auto;
  min-width: 0;
  border: 0;
  outline: none;
  background: transparent;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #070808;
  padding: 0 6px 0 0;
  line-height: 1.25;
}

.agce-margin-twap-duration-input::placeholder {
  color: #c3c6c8;
  font-weight: 500;
}

.agce-margin-twap-duration-suffix {
  flex-shrink: 0;
  font-size: 13px;
  font-weight: 600;
  color: #070808;
  padding-right: 10px;
}

.agce-margin-twap-duration-divider {
  width: 1px;
  flex-shrink: 0;
  background: #dfe0e2;
  align-self: stretch;
  margin: 6px 0;
}

.agce-margin-twap-preset-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.agce-margin-twap-preset {
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(25% - 8px);
  min-width: 56px;
  height: 36px;
  margin: 0;
  padding: 0 8px;
  border: none;
  border-radius: 8px;
  background: #f0f1f3;
  color: #0f172a;
  font-size: 13px;
  font-weight: 600;
  font-family: "Inter", sans-serif;
  cursor: pointer;
  transition: background 0.15s ease;
}

.agce-margin-twap-preset:hover {
  background: #e4e6ea;
}

.agce-margin-twap-advanced-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 0 0 0.25rem;
  padding: 10px 4px 10px 2px;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: left;
  font-family: "Inter", sans-serif;
}

.agce-margin-twap-advanced-toggle__label {
  font-size: 13px;
  font-weight: 500;
}

.agce-margin-twap-advanced-toggle__icon {
  font-size: 20px;
  color: #64748b;
  line-height: 1;
}

.agce-margin-twap-advanced-panel {
  padding-top: 2px;
}

/* TWAP advanced — click-to-open value lists + chevron affordance */
.agce-margin-twap-pick-field {
  position: relative;
}

.agce-margin-twap-per-pick {
  position: relative;
}

button.agce-margin-twap-pick-rowbtn {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  width: 100%;
  min-height: 38px;
  margin: 0;
  padding: 0 10px 0 2px;
  box-sizing: border-box;
  border: 0;
  background: transparent;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #070808;
  text-align: left;
  cursor: pointer;
  outline: none;
  gap: 6px;
}

button.agce-margin-twap-pick-rowbtn--muted {
  color: #c3c6c8;
}

button.agce-margin-twap-pick-rowbtn--per {
  min-height: calc(1.5em + 0.75rem + 2px);
}

.agce-margin-twap-pick-rowbtn__text {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.agce-margin-twap-pick-rowbtn__unit {
  flex-shrink: 0;
  padding-left: 4px;
  font-size: 13px;
  font-weight: 500;
  color: #070808;
}

.agce-margin-twap-pick__chev {
  flex-shrink: 0;
  font-size: 18px;
  color: #64748b;
  line-height: 1;
  margin-left: 2px;
}

.agce-margin-twap-pick-field.is-open .agce-margin-twap-pick__chev,
.agce-margin-twap-interval-row.is-open .agce-margin-twap-pick__chev,
.agce-margin-twap-per-pick.is-open .agce-margin-twap-pick__chev {
  color: #475569;
}

/* TWAP Time Interval — one filled row: value (Limit-style input) + Hour|Minute + chevron */
.trade_price_field.agce-margin-twap-interval-row {
  position: relative;
}

.agce-margin-twap-interval-unit-wrap {
  position: relative;
  flex-shrink: 0;
  display: flex;
  align-items: stretch;
  align-self: stretch;
  margin-left: 7px;
  padding-left: 2px;
  border-left: 1px solid #dfe0e2;
}

.agce-margin-twap-interval-unit-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin: 0;
  padding: 0 10px 0 8px;
  border: 0;
  background: transparent;
  font-family: "Inter", sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #070808;
  cursor: pointer;
  white-space: nowrap;
  outline: none;
}

.agce-margin-twap-interval-unit-btn:focus-visible {
  box-shadow: none;
}

.agce-margin-twap-interval-unit-wrap .agce-margin-twap-pick__menu {
  left: auto;
  right: 0;
  min-width: 8.5rem;
}

.agce-margin-twap-pick__menu {
  position: absolute;
  left: 0;
  right: 0;
  top: calc(100% + 4px);
  z-index: 30;
  list-style: none;
  margin: 0;
  padding: 4px 0;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.12);
  max-height: 240px;
  overflow-y: auto;
}

.agce-margin-twap-pick__menu-item {
  margin: 0;
  padding: 0;
}

.agce-margin-twap-pick__option {
  display: block;
  width: 100%;
  margin: 0;
  padding: 10px 14px;
  border: none;
  background: transparent;
  text-align: left;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #0f172a;
  cursor: pointer;
}

.agce-margin-twap-pick__option:hover {
  background: #f1f5f9;
}

.agce-margin-twap-per-pick .agce-margin-twap-pick__menu {
  left: 0;
  right: 0;
}

.agce-margin-twap-est-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  font-family: "Inter", sans-serif;
  font-size: 13px;
  color: #475569;
}

.agce-margin-twap-est-label {
  flex: 1 1 auto;
  line-height: 1.35;
  max-width: 58%;
}

.agce-margin-twap-est-val {
  flex-shrink: 0;
  font-weight: 600;
  color: #070808;
  text-align: right;
}

@media (max-width: 991px) {

  .trade_card.trade_chart.buysell_card.buysell_two .treade_card_header.buysell_heder.d-block .bs_box_header {
    margin-bottom: 3px;
    padding: 8px 0px 0px;
  }

  .trade_card.trade_chart.buysell_card.buysell_two .bs_box_header {
    padding: 8px 10px 0px;
  }

  h3.headingspot {
    display: none;
  }

  .spot_limit .spot_limit_dd_btn {
    padding: 4px 0 8px;
  }


}

@media (max-width: 767px) {

  .agce-margin-lvg-btn {
    padding: 8px 14px;
    border-radius: 8px;
    font-size: 13px;
  }

  .agce-margin-lvg-input {
    padding: 10px 36px 10px 10px;
    font-size: 13px;
  }

  .agce-margin-lvg-modal-root {
    align-items: end;
  }

  .agce-margin-lvg-modal-panel {
    border-radius: 14px 14px 0px 0px;
    max-width: 100%;
  }

  .agce-margin-ordty-modal-root {
    align-items: end;
  }


  .agce-margin-ordty-modal-panel {
    width: 100%;
    max-width: 100%;
    border-radius: 14px 14px 0px 0px;
  }

  .agce-margin-leverage-row {
    padding-left: 0px;
    padding-right: 0px;
  }

}

/* Futures Margin Balance Row Styles */
.agce-futures-margin-dotted-label {
  text-decoration: underline;
  text-decoration-style: dotted;
  text-underline-offset: 4px;
  cursor: help;
}

.agce-futures-margin-value-container {
  font-weight: 500;
  font-family: "Inter", sans-serif;
  display: flex;
  align-items: center;
}

.agce-futures-margin-val-green {
  color: #03c087 !important;
  font-weight: 600;
}

.agce-futures-margin-divider {
  color: #64748b;
  margin: 0 4px;
}

.agce-futures-margin-val-red {
  color: #ef4444 !important;
  font-weight: 600;
}

.agce-futures-margin-currency {
  font-weight: 500;
  margin-left: 4px;
}

body.light_theme .agce-futures-margin-divider {
  color: #94a3b8;
}

/* Futures Points Card Styles */
.agce-futures-points-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #edeff2;
  border-radius: 8px;
  padding: 10px 14px;
  background: #ffffff;
  text-decoration: none !important;
  transition: all 0.2s ease;
  cursor: pointer;
  width: 100%;
  margin-top: 15px !important;
}

/* .agce-futures-points-card:hover {
  background: #fbfbfc;
  border-color: #e2e8f0;
} */

/* body.dark-mode .agce-futures-points-card,
html[data-theme="dark"] .agce-futures-points-card {
  border-color: #2a2e39;
  background: #1e222d;
}

body.dark-mode .agce-futures-points-card:hover,
html[data-theme="dark"] .agce-futures-points-card:hover {
  background: #262a35;
  border-color: #3a3e49;
} */

.agce-futures-points-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.agce-futures-points-badge-icon {
  width: 24px;
  height: 24px;
  background: #e6f9f3;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #00c087;
  font-size: 14px;
  flex-shrink: 0;
}

body.dark-mode .agce-futures-points-badge-icon,
html[data-theme="dark"] .agce-futures-points-badge-icon {
  background: rgba(0, 192, 135, 0.15);
}

.agce-futures-points-text {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 600;
  font-style: italic;
  color: #00c087;
  display: flex;
  align-items: center;
  gap: 4px;
}

.agce-futures-points-spark {
  font-size: 12px;
  font-style: normal;
}

.agce-futures-points-right {
  color: #94a3b8;
  font-size: 16px;
  display: flex;
  align-items: center;
}

/* --- LEVERAGE TOGGLE SWITCH UI --- */
.agce-margin-leverage-trigger-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: none;
  border: none;
  padding: 4px 0 8px;
  cursor: pointer;
  outline: none;
  font-family: "Inter", sans-serif;
}

/* Switch container wrapper */
.agce-margin-leverage-switch-visual {
  position: relative;
  display: inline-block;
  width: 34px;
  height: 20px;
  pointer-events: none;
  /* Let click pass to the button */
}

/* Slider styling */
.agce-margin-leverage-slider-visual {
  position: absolute;
  inset: 0;
  background-color: #cbd5e1;
  /* Off: gray */
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 999px;
}

/* Slider knob */
.agce-margin-leverage-slider-visual:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
}

/* Active status styles */
.agce-margin-leverage-slider-visual.is-active {
  background-color: #10b981;
  /* Premium Emerald green */
}

.agce-margin-leverage-slider-visual.is-active:before {
  transform: translateX(14px);
}

.agce-margin-leverage-label {
  color: #64748b;
  font-size: 14px;
  font-weight: 500;
  transition: color 0.15s ease;
}

.agce-margin-leverage-slider-visual.is-active~.agce-margin-leverage-label {
  color: #0f172a;
}

.agce-margin-leverage-value {
  color: #0f172a;
  font-weight: 600;
  font-size: 14px;
}

.agce-margin-leverage-trigger-btn i {
  font-size: 16px;
  color: #64748b;
  margin-left: 2px;
}

/* Dark mode compatibility */
body.dark_theme .agce-margin-leverage-slider-visual {
  background-color: #475569;
}

body.dark_theme .agce-margin-leverage-label {
  color: #94a3b8;
}

body.dark_theme .agce-margin-leverage-slider-visual.is-active~.agce-margin-leverage-label {
  color: #f8fafc;
}

body.dark_theme .agce-margin-leverage-value {
  color: #f8fafc;
}

/* ==========================================
   Dark Theme (Default) Overrides for Modals
   ========================================== */
body:not(.light_theme) .agce-margin-lvg-modal-backdrop,
body:not(.light_theme) .agce-margin-ordty-modal-backdrop {
  background: rgba(0, 0, 0, 0.7);
}

body:not(.light_theme) .agce-margin-lvg-modal-panel,
body:not(.light_theme) .agce-margin-ordty-modal-panel {
  background: #111214;
  border: 1px solid rgba(255, 255, 255, 0.12);
  color: #ffffff;
}

body:not(.light_theme) .agce-margin-lvg-modal-head,
body:not(.light_theme) .agce-margin-ordty-modal-head {
  border-bottom-color: rgba(255, 255, 255, 0.1);
}

body:not(.light_theme) .agce-margin-lvg-modal-title,
body:not(.light_theme) .agce-margin-ordty-modal-title {
  color: #ffffff;
}

body:not(.light_theme) .agce-margin-lvg-modal-close,
body:not(.light_theme) .agce-margin-ordty-modal-close {
  color: #94a3b8;
}

body:not(.light_theme) .agce-margin-lvg-modal-close:hover,
body:not(.light_theme) .agce-margin-ordty-modal-close:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #ffffff;
}

body:not(.light_theme) .agce-margin-lvg-field-label {
  color: #94a3b8;
}

body:not(.light_theme) .agce-margin-lvg-coin-row {
  color: #ffffff;
}

body:not(.light_theme) .agce-margin-lvg-input {
  border-color: rgba(255, 255, 255, 0.15);
  background: #1e2329;
  color: #ffffff;
}

body:not(.light_theme) .agce-margin-lvg-input:focus {
  border-color: #ffffff;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.08);
}

body:not(.light_theme) .agce-margin-lvg-quick button {
  border-color: rgba(255, 255, 255, 0.1);
  background: #1e2329;
  color: #e2e8f0;
}

body:not(.light_theme) .agce-margin-lvg-quick button:hover {
  background: rgba(255, 255, 255, 0.08);
}

body:not(.light_theme) .agce-margin-lvg-quick button.is-active {
  border-color: #ffffff;
  background: #ffffff;
  color: #111214;
}

body:not(.light_theme) .agce-margin-lvg-stat dt {
  color: #94a3b8;
}

body:not(.light_theme) .agce-margin-lvg-stat dd {
  color: #ffffff;
}

body:not(.light_theme) .agce-margin-lvg-btn--ghost {
  background: rgba(255, 255, 255, 0.08);
  color: #ffffff;
}

body:not(.light_theme) .agce-margin-lvg-btn--ghost:hover {
  background: rgba(255, 255, 255, 0.15);
}

body:not(.light_theme) .agce-margin-lvg-btn--primary,
body:not(.light_theme) .agce-margin-lvg-modal-foot .agce-margin-lvg-btn--primary {
  background: #d1aa67 !important;
  color: #1e2329 !important;
}

body:not(.light_theme) .agce-margin-lvg-btn--primary:hover,
body:not(.light_theme) .agce-margin-lvg-modal-foot .agce-margin-lvg-btn--primary:hover {
  filter: brightness(1.05);
  background: #d1aa67 !important;
}

body:not(.light_theme) .agce-margin-ordty-option {
  border-color: rgba(255, 255, 255, 0.1);
  background: #1e2329;
}

body:not(.light_theme) .agce-margin-ordty-option:hover {
  border-color: rgba(255, 255, 255, 0.2);
}

body:not(.light_theme) .agce-margin-ordty-option.is-selected {
  border-color: #ffffff;
}

body:not(.light_theme) .agce-margin-ordty-option-title {
  color: #ffffff;
}

body:not(.light_theme) .agce-margin-ordty-option-desc {
  color: #94a3b8;
}

body:not(.light_theme) .agce-margin-ordty-btn-confirm {
  background: #ffffff;
  color: #111214;
}

body:not(.light_theme) .agce-margin-ordty-btn-confirm:hover {
  background: #e2e8f0;
}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/futures_trade/margin.css"],"names":[],"mappings":"AAAA;;;kFAGkF;;AAElF;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;GAEG;;AAEH;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;;;GAGG;;AAEH;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;;AAGA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA,yFAAyF;AACzF;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,uEAAuE;AACzE;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,kCAAkC;EAClC,kCAA0B;UAA1B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;EAClC,cAAc;EACd,2CAA2C;EAC3C,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,UAAU;AACZ;;AAEA;;GAEG;;AAEH;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA,wGAAwG;AACxG;EACE,YAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAa;EACb,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA,8CAA8C;AAC9C;EACE,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,kCAAkC;EAClC,kCAA0B;UAA1B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,2CAA2C;EAC3C,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,0DAA0D;AAC5D;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA,8FAA8F;AAC9F;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,SAAS;EACT,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,4FAA4F;AAC5F;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,uGAAuG;AACvG;;;;;;;EAOE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;;;EAcE,6BAA6B;EAC7B,8BAA8B;EAC9B,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA,oFAAoF;AACpF;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,oBAAoB;EACpB,SAAS;EACT,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,8CAA8C;EAC9C,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,SAAS;EACT,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA,sEAAsE;AACtE;EACE,aAAa;EACb,oBAAoB;EACpB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;EACT,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,UAAU;EACV,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,4EAA4E;AAC5E;EACE,aAAa;EACb,oBAAoB;EACpB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,YAAyB;EAAzB,cAAyB;EAAzB,2BAAyB;EACzB,eAAe;EACf,YAAY;EACZ,SAAS;EACT,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;EACnB,0BAA0B;EAC1B,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mEAAmE;AACnE;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,qBAAqB;EACrB,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA,2FAA2F;AAC3F;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,qBAAqB;EACrB,SAAS;EACT,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,8CAA8C;EAC9C,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE;IACE,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;;AAGF;;AAEA;;EAEE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,4BAA4B;IAC5B,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gCAAgC;IAChC,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;;EAGA;IACE,WAAW;IACX,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;AAEF;;AAEA,sCAAsC;AACtC;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,yBAAyB;EACzB,eAAe;EACf,WAAW;EACX,2BAA2B;AAC7B;;AAEA;;;GAGG;;AAEH;;;;;;;;;;GAUG;;AAEH;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA,sCAAsC;AACtC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,gCAAgC;AAClC;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,QAAQ;EACR,yBAAyB;EACzB,cAAc;EACd,iDAAiD;EACjD,oBAAoB;AACtB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,iDAAiD;EACjD,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;+CAE+C;AAC/C;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,mBAAmB;EACnB,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;;EAEE,6CAA6C;AAC/C;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;EAEE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;;EAEE,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* =============================================================================\n   Margin trading page — leverage trigger + Adjust Leverage modal\n   (Loaded from margin/index.js; scoped with .agce-margin- prefix.)\n   ============================================================================= */\n\n.agce-margin-leverage-row {\n  padding: 0px;\n  border-bottom: none;\n}\n\n/* body.light_theme .agce-margin-leverage-row {\n  border-bottom-color: rgba(15, 23, 42, 0.08);\n} */\n\n.agce-margin-leverage-trigger {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  width: 100%;\n  max-width: 100%;\n  justify-content: start;\n  padding: 2px 0px 8px;\n  border-radius: 0px;\n  border: none;\n  background: none;\n  color: #e2e8f0;\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n/* .agce-margin-leverage-trigger:hover {\n  background: rgba(255, 255, 255, 0.07);\n  border-color: rgba(255, 255, 255, 0.16);\n} */\n\n.agce-margin-leverage-trigger {\n  border-color: transparent;\n  background: none;\n  color: #0f172a;\n}\n\n\n.agce-margin-leverage-label {\n  color: #94a3b8;\n  font-weight: 500;\n}\n\n.agce-margin-leverage-label {\n  color: #64748b;\n}\n\n.agce-margin-leverage-value {\n  color: #f8fafc;\n  font-weight: 600;\n}\n\n.agce-margin-leverage-value {\n  color: #0f172a;\n}\n\n.agce-margin-leverage-trigger i {\n  font-size: 18px;\n  opacity: 0.85;\n  margin-left: 2px;\n}\n\n/* Spot / Cross / Isolated / ETF / Futures — single row + horizontal scroll when narrow */\n.agce-margin-surface-tabs-outer {\n  min-width: 0;\n}\n\n.agce-margin-surface-tabs-scroll-wrap {\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\n.agce-margin-surface-tabs-scroller {\n  min-width: 0;\n  overflow-x: auto;\n  overflow-y: hidden;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n}\n\n.agce-margin-surface-tabs-scroller::-webkit-scrollbar {\n  display: none;\n}\n\n.margin-surface-tabs .margin_surface_tab_strip>button {\n  flex-shrink: 0;\n}\n\n.agce-margin-surface-tab-scroll-btn {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  color: #94a3b8;\n  cursor: pointer;\n  transition: color 0.15s ease, background 0.15s ease, opacity 0.15s ease;\n}\n\n.agce-margin-surface-tab-scroll-btn:hover:not(:disabled) {\n  color: #e2e8f0;\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.agce-margin-surface-tab-scroll-btn:disabled {\n  opacity: 0.28;\n  cursor: default;\n  pointer-events: none;\n}\n\nbody.light_theme .agce-margin-surface-tab-scroll-btn {\n  color: #84888c;\n}\n\nbody.light_theme .agce-margin-surface-tab-scroll-btn:hover:not(:disabled) {\n  color: #0f172a;\n  background: rgba(15, 23, 42, 0.06);\n}\n\n/* ——— Modal ——— */\n.agce-margin-lvg-modal-root {\n  position: fixed;\n  inset: 0;\n  z-index: 10600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0px;\n  z-index: 99999999;\n}\n\n.agce-margin-lvg-modal-backdrop {\n  position: absolute;\n  inset: 0;\n  background: rgb(255 255 255 / 20%);\n  backdrop-filter: blur(5px);\n}\n\n.agce-margin-lvg-modal-panel {\n  position: relative;\n  width: 100%;\n  max-width: 540px;\n  border-radius: 14px;\n  background: rgb(255 255 255 / 20%);\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n  color: #0f172a;\n  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.28);\n  font-family: \"Inter\", sans-serif;\n  overflow: hidden;\n}\n\n.agce-margin-lvg-modal-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 18px 12px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.agce-margin-lvg-modal-title {\n  margin: 0;\n  font-size: 17px;\n  font-weight: 700;\n}\n\n.agce-margin-lvg-modal-close {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border: none;\n  border-radius: 10px;\n  background: transparent;\n  color: #64748b;\n  cursor: pointer;\n}\n\n.agce-margin-lvg-modal-close:hover {\n  background: #f1f5f9;\n  color: #0f172a;\n}\n\n.agce-margin-lvg-modal-body {\n  padding: 16px 18px 8px;\n}\n\n.agce-margin-lvg-field-label {\n  display: block;\n  font-size: 12px;\n  font-weight: 500;\n  color: #64748b;\n  margin-bottom: 6px;\n}\n\n.agce-margin-lvg-coin-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 16px;\n  font-weight: 700;\n  margin-bottom: 18px;\n}\n\n.agce-margin-lvg-coin-row img {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n}\n\n.agce-margin-lvg-input-wrap {\n  position: relative;\n  margin-bottom: 12px;\n}\n\n.agce-margin-lvg-input {\n  width: 100%;\n  padding: 12px 40px 12px 12px;\n  border: 1px solid #cbd5e1;\n  border-radius: 10px;\n  font-size: 15px;\n  font-weight: 800;\n  outline: none;\n}\n\n.agce-margin-lvg-input:focus {\n  border-color: #0f172a;\n  box-shadow: 0 0 0 2px rgba(15, 23, 42, 0.08);\n}\n\n.agce-margin-lvg-stepper {\n  position: absolute;\n  right: 6px;\n  top: 50%;\n  transform: translateY(-50%);\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.agce-margin-lvg-stepper button {\n  width: 22px;\n  height: 12px;\n  border: none;\n  background: none;\n  border-radius: 4px;\n  font-size: 10px;\n  line-height: 1;\n  cursor: pointer;\n  padding: 0;\n}\n\n/* .agce-margin-lvg-stepper button:hover {\n  background: #e2e8f0;\n} */\n\n.agce-margin-lvg-quick {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 18px;\n}\n\n.agce-margin-lvg-quick button {\n  min-width: 52px;\n  padding: 8px 6px;\n  border-radius: 999px;\n  border: 1px solid #e2e8f0;\n  background: #f8fafc;\n  font-size: 13px;\n  font-weight: 600;\n  color: #334155;\n  cursor: pointer;\n}\n\n.agce-margin-lvg-quick button:hover {\n  background: #e2e8f0;\n}\n\n.agce-margin-lvg-quick button.is-active {\n  border-color: #0f172a;\n  background: #fff;\n  color: #0f172a;\n}\n\n.agce-margin-lvg-stats {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n\n.agce-margin-lvg-stat {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 13px;\n}\n\n.agce-margin-lvg-stat dt {\n  margin: 0;\n  color: #64748b;\n  font-weight: 500;\n}\n\n.agce-margin-lvg-stat dd {\n  margin: 0;\n  font-weight: 600;\n  color: #0f172a;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.agce-margin-lvg-warn {\n  font-size: 12px;\n  line-height: 1.45;\n  color: #ea580c;\n  margin: 0 0 8px;\n}\n\n.agce-margin-lvg-modal-body .agce-margin-lvg-defaults {\n  margin-top: 8px;\n  margin-bottom: 0;\n}\n\n.agce-margin-lvg-modal-foot {\n  display: flex;\n  gap: 10px;\n  padding: 14px 18px 18px;\n}\n\n.agce-margin-lvg-btn {\n  flex: 1;\n  padding: 12px 14px;\n  border-radius: 10px;\n  font-size: 15px;\n  font-weight: 600;\n  border: none;\n  cursor: pointer;\n}\n\n.agce-margin-lvg-btn--ghost {\n  background: #f1f5f9;\n  color: #0f172a;\n}\n\n.agce-margin-lvg-btn--ghost:hover {\n  background: #e2e8f0;\n}\n\n.agce-margin-lvg-btn--primary {\n  background: #d1aa67;\n  color: #14161a;\n}\n\n.agce-margin-lvg-btn--primary:hover {\n  filter: brightness(1.05);\n  background: #d1aa67;\n}\n\n/* Foot layout + primary — higher specificity so shared margin/*.css cannot reset flex / white Confirm */\n.agce-margin-lvg-modal-foot .agce-margin-lvg-btn--ghost {\n  flex: 0.65 1 0;\n  max-width: 34%;\n}\n\n.agce-margin-lvg-modal-foot .agce-margin-lvg-btn--primary {\n  flex: 2.1 1 0;\n  background: #d1aa67 !important;\n  color: #14161a !important;\n}\n\n.agce-margin-lvg-modal-foot .agce-margin-lvg-btn--primary:hover {\n  filter: brightness(1.05);\n  background: #d1aa67 !important;\n}\n\n/* ——— Advanced Limit — Order Type modal ——— */\n.agce-margin-ordty-modal-root {\n  position: fixed;\n  inset: 0;\n  z-index: 9999999999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0px;\n}\n\n.agce-margin-ordty-modal-backdrop {\n  position: absolute;\n  inset: 0;\n  background: rgb(255 255 255 / 20%);\n  backdrop-filter: blur(5px);\n}\n\n.agce-margin-ordty-modal-panel {\n  position: relative;\n  width: 100%;\n  max-width: 440px;\n  max-height: min(92vh, 640px);\n  display: flex;\n  flex-direction: column;\n  border-radius: 14px;\n  background: #ffffff;\n  color: #0f172a;\n  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.28);\n  font-family: \"Inter\", sans-serif;\n  overflow: hidden;\n}\n\n.agce-margin-ordty-modal-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-shrink: 0;\n  padding: 16px 18px 12px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.agce-margin-ordty-modal-title {\n  margin: 0;\n  font-size: 17px;\n  font-weight: 700;\n}\n\n.agce-margin-ordty-modal-close {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border: none;\n  border-radius: 10px;\n  background: transparent;\n  color: #64748b;\n  cursor: pointer;\n}\n\n.agce-margin-ordty-modal-close:hover {\n  background: #f1f5f9;\n  color: #0f172a;\n}\n\n.agce-margin-ordty-modal-body {\n  flex: 1 1 auto;\n  overflow-y: auto;\n  padding: 14px 18px 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.agce-margin-ordty-option {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 6px;\n  width: 100%;\n  margin: 0;\n  padding: 12px 14px;\n  text-align: left;\n  border-radius: 10px;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  cursor: pointer;\n  font-family: \"Inter\", sans-serif;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.agce-margin-ordty-option:hover {\n  border-color: #cbd5e1;\n}\n\n.agce-margin-ordty-option.is-selected {\n  border-width: 1px;\n  border-color: #c6c6c6;\n  padding: 11px 13px;\n  box-shadow: 0 0 0 1px rgba(15, 23, 42, 0.06);\n}\n\n.agce-margin-ordty-option-title {\n  font-size: 15px;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.agce-margin-ordty-option-desc {\n  font-size: 13px;\n  line-height: 1.45;\n  font-weight: 500;\n  color: #64748b;\n}\n\n.agce-margin-ordty-modal-foot {\n  flex-shrink: 0;\n  padding: 14px 18px 18px;\n}\n\n.agce-margin-ordty-btn-confirm {\n  width: 100%;\n  padding: 14px 16px;\n  border-radius: 10px;\n  border: none;\n  background: #0f172a;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 600;\n  font-family: \"Inter\", sans-serif;\n  cursor: pointer;\n}\n\n.agce-margin-ordty-btn-confirm:hover {\n  background: #1e293b;\n}\n\n@media (max-width: 991px) {\n  .agce-margin-leverage-row {\n    padding-left: 8px;\n    padding-right: 8px;\n  }\n}\n\n/* TP/SL — one Market/Limit toggle; same fill + radius as .trade_price_field (trade_new.css) */\n.agce-margin-tp-sl-price-row {\n  flex-wrap: nowrap;\n}\n\n.agce-margin-tp-sl-toggle-btn {\n  flex-shrink: 0;\n  align-self: stretch;\n  min-width: 72px;\n  height: 40px;\n  margin: 0;\n  padding: 0 14px;\n  box-sizing: border-box;\n  border: none;\n  border-radius: 8px;\n  background: #f6f6f7;\n  color: #070808;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  font-family: \"Inter\", sans-serif;\n  transition: background 0.15s ease, box-shadow 0.15s ease;\n}\n\n.agce-margin-tp-sl-toggle-btn:hover {\n  background: #ececed;\n}\n\n.agce-margin-tp-sl-toggle-btn:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 1px rgba(30, 144, 255, 0.45);\n}\n\nbody.light_theme .agce-margin-tp-sl-toggle-btn {\n  background: #f6f6f7;\n  color: #070808;\n}\n\nbody.light_theme .agce-margin-tp-sl-toggle-btn:hover {\n  background: #ececed;\n}\n\n/* Conditional — Order Price: strong border when execution is Market (matches mobile ref). */\n.margin-advanced-block--cond .agce-margin-tp-sl-toggle-btn[aria-pressed=\"false\"] {\n  background: #f5f5f5;\n  font-weight: 500;\n}\n\n.margin-advanced-block--cond .agce-margin-tp-sl-toggle-btn[aria-pressed=\"true\"] {\n  border: 1px solid #e2e8f0;\n}\n\n/* TP/SL + TWAP + Iceberg — extra breathing room for quote/base suffix (USDT, BTC) inside filled rows */\n.margin-advanced-block--tp-sl .trade_price_suffix,\n.margin-advanced-block--twap .trade_price_suffix,\n.margin-advanced-block--iceberg .trade_price_suffix,\n.margin-advanced-block--loop .trade_price_suffix,\n.margin-advanced-block--trail .trade_price_suffix,\n.margin-advanced-block--adv-lim .trade_price_suffix,\n.margin-advanced-block--cond .trade_price_suffix {\n  padding-left: 10px;\n  padding-right: 14px;\n}\n\n.margin-advanced-block--tp-sl .trade_amount_field_limit>.input-group-text.trade_amount_coin_badge,\n.margin-advanced-block--tp-sl .trade_amount_field_limit>.input-group-text,\n.margin-advanced-block--twap .trade_amount_field_limit>.input-group-text.trade_amount_coin_badge,\n.margin-advanced-block--twap .trade_amount_field_limit>.input-group-text,\n.margin-advanced-block--iceberg .trade_amount_field_limit>.input-group-text.trade_amount_coin_badge,\n.margin-advanced-block--iceberg .trade_amount_field_limit>.input-group-text,\n.margin-advanced-block--loop .trade_amount_field_limit>.input-group-text.trade_amount_coin_badge,\n.margin-advanced-block--loop .trade_amount_field_limit>.input-group-text,\n.margin-advanced-block--trail .trade_amount_field_limit>.input-group-text.trade_amount_coin_badge,\n.margin-advanced-block--trail .trade_amount_field_limit>.input-group-text,\n.margin-advanced-block--adv-lim .trade_amount_field_limit>.input-group-text.trade_amount_coin_badge,\n.margin-advanced-block--adv-lim .trade_amount_field_limit>.input-group-text,\n.margin-advanced-block--cond .trade_amount_field_limit>.input-group-text.trade_amount_coin_badge,\n.margin-advanced-block--cond .trade_amount_field_limit>.input-group-text {\n  padding-left: 10px !important;\n  padding-right: 14px !important;\n  min-width: 3.25rem;\n  justify-content: center;\n}\n\n/* Loop Order — price row (optional + quote | mode), Valid for row, dropdown menus */\n.trade_price_field.agce-margin-loop-price-row {\n  position: relative;\n  align-items: center;\n  padding-right: 4px;\n}\n\n.agce-margin-loop-price-quote {\n  flex-shrink: 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: #070808;\n  padding-right: 2px;\n}\n\n.agce-margin-loop-price-bar {\n  flex-shrink: 0;\n  padding: 0 6px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #c3c6c8;\n  user-select: none;\n}\n\n.agce-margin-loop-price-mode {\n  position: relative;\n  flex-shrink: 0;\n  display: flex;\n  align-items: stretch;\n  align-self: stretch;\n  margin-left: 4px;\n  padding-left: 6px;\n  border-left: 1px solid #dfe0e2;\n}\n\n.agce-margin-loop-price-mode-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  margin: 0;\n  padding: 0 8px 0 4px;\n  border: 0;\n  background: transparent;\n  font-family: \"Inter\", sans-serif;\n  font-size: 13px;\n  font-weight: 600;\n  color: #070808;\n  cursor: pointer;\n  white-space: nowrap;\n  outline: none;\n}\n\n.agce-margin-loop-price-mode-btn:focus-visible {\n  box-shadow: none;\n}\n\n.agce-margin-loop-price-mode-chev {\n  font-size: 18px;\n  color: #64748b;\n  line-height: 1;\n  margin-left: 2px;\n}\n\n.agce-margin-loop-price-row.is-open .agce-margin-loop-price-mode-chev,\n.agce-margin-loop-valid-wrap.is-open .agce-margin-loop-valid-chev {\n  color: #475569;\n}\n\n.trade_price_field.agce-margin-loop-valid-wrap {\n  position: relative;\n  padding: 0;\n}\n\n.agce-margin-loop-valid-btn {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  min-height: 40px;\n  margin: 0;\n  padding: 0 12px 0 12px;\n  border: 0;\n  background: transparent;\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  color: #070808;\n  text-align: left;\n  cursor: pointer;\n  outline: none;\n}\n\n.agce-margin-loop-valid-btn:focus-visible {\n  box-shadow: none;\n}\n\n.agce-margin-loop-valid-btn__text {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.agce-margin-loop-valid-chev {\n  font-size: 18px;\n  color: #64748b;\n  line-height: 1;\n  flex-shrink: 0;\n  margin-left: 8px;\n}\n\n.agce-margin-loop-price-mode .agce-margin-loop-pick__menu {\n  left: auto;\n  right: 0;\n  min-width: 11rem;\n}\n\n.agce-margin-loop-valid-wrap .agce-margin-loop-pick__menu {\n  left: 0;\n  right: 0;\n}\n\n.agce-margin-loop-pick__menu {\n  position: absolute;\n  top: calc(100% + 4px);\n  z-index: 30;\n  list-style: none;\n  margin: 0;\n  padding: 4px 0;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.12);\n  max-height: 240px;\n  overflow-y: auto;\n}\n\n.agce-margin-loop-pick__menu-item {\n  margin: 0;\n  padding: 0;\n}\n\n.agce-margin-loop-pick__option {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  width: 100%;\n  margin: 0;\n  padding: 6px 14px;\n  border: none;\n  background: transparent;\n  text-align: left;\n  font-family: \"Inter\", sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  color: #0f172a;\n  cursor: pointer;\n}\n\n.agce-margin-loop-pick__option:hover {\n  background: #f1f5f9;\n}\n\n.agce-margin-loop-pick__check {\n  flex-shrink: 0;\n  font-size: 18px;\n  color: #1e90ff;\n  line-height: 1;\n}\n\n.agce-margin-loop-pick__check-slot {\n  flex-shrink: 0;\n  width: 18px;\n  height: 18px;\n}\n\n/* Trailing Stop — pullback: filled row + %|USDT unit menu + 5% chip */\n.agce-margin-trail-pullback-row {\n  display: flex;\n  align-items: stretch;\n  gap: 8px;\n  width: 100%;\n}\n\n.agce-margin-trail-pullback-field.trade_price_field {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.agce-margin-trail-preset-chip {\n  flex-shrink: 0;\n  min-width: 52px;\n  margin: 0;\n  padding: 0 12px;\n  box-sizing: border-box;\n  height: 40px;\n  align-self: stretch;\n  border: none;\n  border-radius: 8px;\n  background: #f6f6f7;\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  color: #070808;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.agce-margin-trail-preset-chip:hover {\n  background: #ececed;\n}\n\n.agce-margin-trail-preset-chip:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 1px rgba(30, 144, 255, 0.45);\n}\n\n.agce-margin-twap-interval-unit-wrap.agce-margin-trail-pull-unit .agce-margin-loop-pick__menu {\n  left: auto;\n  right: 0;\n  min-width: 8rem;\n}\n\n.agce-margin-iceberg-section-title {\n  margin: 0 0 10px 2px;\n  padding: 0;\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  color: #1f1f1f;\n}\n\n/* TWAP — duration split (H | M), presets, advanced toggle, inline selects */\n.agce-margin-twap-duration-shell {\n  display: flex;\n  align-items: stretch;\n  flex-wrap: nowrap;\n  width: 100%;\n  min-height: 40px;\n  box-sizing: border-box;\n  background: #f6f6f7;\n  border-radius: 8px;\n  overflow: hidden;\n  font-family: \"Inter\", sans-serif;\n}\n\n.agce-margin-twap-duration-cell {\n  flex: 1 1 50%;\n  display: flex;\n  align-items: center;\n  min-width: 0;\n  padding: 0 4px 0 12px;\n}\n\n.agce-margin-twap-duration-input {\n  flex: 1 1 auto;\n  min-width: 0;\n  border: 0;\n  outline: none;\n  background: transparent;\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  color: #070808;\n  padding: 0 6px 0 0;\n  line-height: 1.25;\n}\n\n.agce-margin-twap-duration-input::placeholder {\n  color: #c3c6c8;\n  font-weight: 500;\n}\n\n.agce-margin-twap-duration-suffix {\n  flex-shrink: 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: #070808;\n  padding-right: 10px;\n}\n\n.agce-margin-twap-duration-divider {\n  width: 1px;\n  flex-shrink: 0;\n  background: #dfe0e2;\n  align-self: stretch;\n  margin: 6px 0;\n}\n\n.agce-margin-twap-preset-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.agce-margin-twap-preset {\n  flex: 1 1 calc(25% - 8px);\n  min-width: 56px;\n  height: 36px;\n  margin: 0;\n  padding: 0 8px;\n  border: none;\n  border-radius: 8px;\n  background: #f0f1f3;\n  color: #0f172a;\n  font-size: 13px;\n  font-weight: 600;\n  font-family: \"Inter\", sans-serif;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.agce-margin-twap-preset:hover {\n  background: #e4e6ea;\n}\n\n.agce-margin-twap-advanced-toggle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  margin: 0 0 0.25rem;\n  padding: 10px 4px 10px 2px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  text-align: left;\n  font-family: \"Inter\", sans-serif;\n}\n\n.agce-margin-twap-advanced-toggle__label {\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.agce-margin-twap-advanced-toggle__icon {\n  font-size: 20px;\n  color: #64748b;\n  line-height: 1;\n}\n\n.agce-margin-twap-advanced-panel {\n  padding-top: 2px;\n}\n\n/* TWAP advanced — click-to-open value lists + chevron affordance */\n.agce-margin-twap-pick-field {\n  position: relative;\n}\n\n.agce-margin-twap-per-pick {\n  position: relative;\n}\n\nbutton.agce-margin-twap-pick-rowbtn {\n  display: flex;\n  align-items: center;\n  flex-wrap: nowrap;\n  width: 100%;\n  min-height: 38px;\n  margin: 0;\n  padding: 0 10px 0 2px;\n  box-sizing: border-box;\n  border: 0;\n  background: transparent;\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  color: #070808;\n  text-align: left;\n  cursor: pointer;\n  outline: none;\n  gap: 6px;\n}\n\nbutton.agce-margin-twap-pick-rowbtn--muted {\n  color: #c3c6c8;\n}\n\nbutton.agce-margin-twap-pick-rowbtn--per {\n  min-height: calc(1.5em + 0.75rem + 2px);\n}\n\n.agce-margin-twap-pick-rowbtn__text {\n  flex: 1 1 auto;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.agce-margin-twap-pick-rowbtn__unit {\n  flex-shrink: 0;\n  padding-left: 4px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #070808;\n}\n\n.agce-margin-twap-pick__chev {\n  flex-shrink: 0;\n  font-size: 18px;\n  color: #64748b;\n  line-height: 1;\n  margin-left: 2px;\n}\n\n.agce-margin-twap-pick-field.is-open .agce-margin-twap-pick__chev,\n.agce-margin-twap-interval-row.is-open .agce-margin-twap-pick__chev,\n.agce-margin-twap-per-pick.is-open .agce-margin-twap-pick__chev {\n  color: #475569;\n}\n\n/* TWAP Time Interval — one filled row: value (Limit-style input) + Hour|Minute + chevron */\n.trade_price_field.agce-margin-twap-interval-row {\n  position: relative;\n}\n\n.agce-margin-twap-interval-unit-wrap {\n  position: relative;\n  flex-shrink: 0;\n  display: flex;\n  align-items: stretch;\n  align-self: stretch;\n  margin-left: 7px;\n  padding-left: 2px;\n  border-left: 1px solid #dfe0e2;\n}\n\n.agce-margin-twap-interval-unit-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  margin: 0;\n  padding: 0 10px 0 8px;\n  border: 0;\n  background: transparent;\n  font-family: \"Inter\", sans-serif;\n  font-size: 13px;\n  font-weight: 600;\n  color: #070808;\n  cursor: pointer;\n  white-space: nowrap;\n  outline: none;\n}\n\n.agce-margin-twap-interval-unit-btn:focus-visible {\n  box-shadow: none;\n}\n\n.agce-margin-twap-interval-unit-wrap .agce-margin-twap-pick__menu {\n  left: auto;\n  right: 0;\n  min-width: 8.5rem;\n}\n\n.agce-margin-twap-pick__menu {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: calc(100% + 4px);\n  z-index: 30;\n  list-style: none;\n  margin: 0;\n  padding: 4px 0;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.12);\n  max-height: 240px;\n  overflow-y: auto;\n}\n\n.agce-margin-twap-pick__menu-item {\n  margin: 0;\n  padding: 0;\n}\n\n.agce-margin-twap-pick__option {\n  display: block;\n  width: 100%;\n  margin: 0;\n  padding: 10px 14px;\n  border: none;\n  background: transparent;\n  text-align: left;\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  color: #0f172a;\n  cursor: pointer;\n}\n\n.agce-margin-twap-pick__option:hover {\n  background: #f1f5f9;\n}\n\n.agce-margin-twap-per-pick .agce-margin-twap-pick__menu {\n  left: 0;\n  right: 0;\n}\n\n.agce-margin-twap-est-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  font-family: \"Inter\", sans-serif;\n  font-size: 13px;\n  color: #475569;\n}\n\n.agce-margin-twap-est-label {\n  flex: 1 1 auto;\n  line-height: 1.35;\n  max-width: 58%;\n}\n\n.agce-margin-twap-est-val {\n  flex-shrink: 0;\n  font-weight: 600;\n  color: #070808;\n  text-align: right;\n}\n\n@media (max-width: 991px) {\n\n  .trade_card.trade_chart.buysell_card.buysell_two .treade_card_header.buysell_heder.d-block .bs_box_header {\n    margin-bottom: 3px;\n    padding: 8px 0px 0px;\n  }\n\n  .trade_card.trade_chart.buysell_card.buysell_two .bs_box_header {\n    padding: 8px 10px 0px;\n  }\n\n  h3.headingspot {\n    display: none;\n  }\n\n  .spot_limit .spot_limit_dd_btn {\n    padding: 4px 0 8px;\n  }\n\n\n}\n\n@media (max-width: 767px) {\n\n  .agce-margin-lvg-btn {\n    padding: 8px 14px;\n    border-radius: 8px;\n    font-size: 13px;\n  }\n\n  .agce-margin-lvg-input {\n    padding: 10px 36px 10px 10px;\n    font-size: 13px;\n  }\n\n  .agce-margin-lvg-modal-root {\n    align-items: end;\n  }\n\n  .agce-margin-lvg-modal-panel {\n    border-radius: 14px 14px 0px 0px;\n    max-width: 100%;\n  }\n\n  .agce-margin-ordty-modal-root {\n    align-items: end;\n  }\n\n\n  .agce-margin-ordty-modal-panel {\n    width: 100%;\n    max-width: 100%;\n    border-radius: 14px 14px 0px 0px;\n  }\n\n  .agce-margin-leverage-row {\n    padding-left: 0px;\n    padding-right: 0px;\n  }\n\n}\n\n/* Futures Margin Balance Row Styles */\n.agce-futures-margin-dotted-label {\n  text-decoration: underline;\n  text-decoration-style: dotted;\n  text-underline-offset: 4px;\n  cursor: help;\n}\n\n.agce-futures-margin-value-container {\n  font-weight: 500;\n  font-family: \"Inter\", sans-serif;\n  display: flex;\n  align-items: center;\n}\n\n.agce-futures-margin-val-green {\n  color: #03c087 !important;\n  font-weight: 600;\n}\n\n.agce-futures-margin-divider {\n  color: #64748b;\n  margin: 0 4px;\n}\n\n.agce-futures-margin-val-red {\n  color: #ef4444 !important;\n  font-weight: 600;\n}\n\n.agce-futures-margin-currency {\n  font-weight: 500;\n  margin-left: 4px;\n}\n\nbody.light_theme .agce-futures-margin-divider {\n  color: #94a3b8;\n}\n\n/* Futures Points Card Styles */\n.agce-futures-points-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border: 1px solid #edeff2;\n  border-radius: 8px;\n  padding: 10px 14px;\n  background: #ffffff;\n  text-decoration: none !important;\n  transition: all 0.2s ease;\n  cursor: pointer;\n  width: 100%;\n  margin-top: 15px !important;\n}\n\n/* .agce-futures-points-card:hover {\n  background: #fbfbfc;\n  border-color: #e2e8f0;\n} */\n\n/* body.dark-mode .agce-futures-points-card,\nhtml[data-theme=\"dark\"] .agce-futures-points-card {\n  border-color: #2a2e39;\n  background: #1e222d;\n}\n\nbody.dark-mode .agce-futures-points-card:hover,\nhtml[data-theme=\"dark\"] .agce-futures-points-card:hover {\n  background: #262a35;\n  border-color: #3a3e49;\n} */\n\n.agce-futures-points-left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.agce-futures-points-badge-icon {\n  width: 24px;\n  height: 24px;\n  background: #e6f9f3;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #00c087;\n  font-size: 14px;\n  flex-shrink: 0;\n}\n\nbody.dark-mode .agce-futures-points-badge-icon,\nhtml[data-theme=\"dark\"] .agce-futures-points-badge-icon {\n  background: rgba(0, 192, 135, 0.15);\n}\n\n.agce-futures-points-text {\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  font-style: italic;\n  color: #00c087;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.agce-futures-points-spark {\n  font-size: 12px;\n  font-style: normal;\n}\n\n.agce-futures-points-right {\n  color: #94a3b8;\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n}\n\n/* --- LEVERAGE TOGGLE SWITCH UI --- */\n.agce-margin-leverage-trigger-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: none;\n  border: none;\n  padding: 4px 0 8px;\n  cursor: pointer;\n  outline: none;\n  font-family: \"Inter\", sans-serif;\n}\n\n/* Switch container wrapper */\n.agce-margin-leverage-switch-visual {\n  position: relative;\n  display: inline-block;\n  width: 34px;\n  height: 20px;\n  pointer-events: none;\n  /* Let click pass to the button */\n}\n\n/* Slider styling */\n.agce-margin-leverage-slider-visual {\n  position: absolute;\n  inset: 0;\n  background-color: #cbd5e1;\n  /* Off: gray */\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  border-radius: 999px;\n}\n\n/* Slider knob */\n.agce-margin-leverage-slider-visual:before {\n  position: absolute;\n  content: \"\";\n  height: 16px;\n  width: 16px;\n  left: 2px;\n  bottom: 2px;\n  background-color: white;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  border-radius: 50%;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);\n}\n\n/* Active status styles */\n.agce-margin-leverage-slider-visual.is-active {\n  background-color: #10b981;\n  /* Premium Emerald green */\n}\n\n.agce-margin-leverage-slider-visual.is-active:before {\n  transform: translateX(14px);\n}\n\n.agce-margin-leverage-label {\n  color: #64748b;\n  font-size: 14px;\n  font-weight: 500;\n  transition: color 0.15s ease;\n}\n\n.agce-margin-leverage-slider-visual.is-active~.agce-margin-leverage-label {\n  color: #0f172a;\n}\n\n.agce-margin-leverage-value {\n  color: #0f172a;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.agce-margin-leverage-trigger-btn i {\n  font-size: 16px;\n  color: #64748b;\n  margin-left: 2px;\n}\n\n/* Dark mode compatibility */\nbody.dark_theme .agce-margin-leverage-slider-visual {\n  background-color: #475569;\n}\n\nbody.dark_theme .agce-margin-leverage-label {\n  color: #94a3b8;\n}\n\nbody.dark_theme .agce-margin-leverage-slider-visual.is-active~.agce-margin-leverage-label {\n  color: #f8fafc;\n}\n\nbody.dark_theme .agce-margin-leverage-value {\n  color: #f8fafc;\n}\n\n/* ==========================================\n   Dark Theme (Default) Overrides for Modals\n   ========================================== */\nbody:not(.light_theme) .agce-margin-lvg-modal-backdrop,\nbody:not(.light_theme) .agce-margin-ordty-modal-backdrop {\n  background: rgba(0, 0, 0, 0.7);\n}\n\nbody:not(.light_theme) .agce-margin-lvg-modal-panel,\nbody:not(.light_theme) .agce-margin-ordty-modal-panel {\n  background: #111214;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .agce-margin-lvg-modal-head,\nbody:not(.light_theme) .agce-margin-ordty-modal-head {\n  border-bottom-color: rgba(255, 255, 255, 0.1);\n}\n\nbody:not(.light_theme) .agce-margin-lvg-modal-title,\nbody:not(.light_theme) .agce-margin-ordty-modal-title {\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .agce-margin-lvg-modal-close,\nbody:not(.light_theme) .agce-margin-ordty-modal-close {\n  color: #94a3b8;\n}\n\nbody:not(.light_theme) .agce-margin-lvg-modal-close:hover,\nbody:not(.light_theme) .agce-margin-ordty-modal-close:hover {\n  background: rgba(255, 255, 255, 0.08);\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .agce-margin-lvg-field-label {\n  color: #94a3b8;\n}\n\nbody:not(.light_theme) .agce-margin-lvg-coin-row {\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .agce-margin-lvg-input {\n  border-color: rgba(255, 255, 255, 0.15);\n  background: #1e2329;\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .agce-margin-lvg-input:focus {\n  border-color: #ffffff;\n  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.08);\n}\n\nbody:not(.light_theme) .agce-margin-lvg-quick button {\n  border-color: rgba(255, 255, 255, 0.1);\n  background: #1e2329;\n  color: #e2e8f0;\n}\n\nbody:not(.light_theme) .agce-margin-lvg-quick button:hover {\n  background: rgba(255, 255, 255, 0.08);\n}\n\nbody:not(.light_theme) .agce-margin-lvg-quick button.is-active {\n  border-color: #ffffff;\n  background: #ffffff;\n  color: #111214;\n}\n\nbody:not(.light_theme) .agce-margin-lvg-stat dt {\n  color: #94a3b8;\n}\n\nbody:not(.light_theme) .agce-margin-lvg-stat dd {\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .agce-margin-lvg-btn--ghost {\n  background: rgba(255, 255, 255, 0.08);\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .agce-margin-lvg-btn--ghost:hover {\n  background: rgba(255, 255, 255, 0.15);\n}\n\nbody:not(.light_theme) .agce-margin-lvg-btn--primary,\nbody:not(.light_theme) .agce-margin-lvg-modal-foot .agce-margin-lvg-btn--primary {\n  background: #d1aa67 !important;\n  color: #1e2329 !important;\n}\n\nbody:not(.light_theme) .agce-margin-lvg-btn--primary:hover,\nbody:not(.light_theme) .agce-margin-lvg-modal-foot .agce-margin-lvg-btn--primary:hover {\n  filter: brightness(1.05);\n  background: #d1aa67 !important;\n}\n\nbody:not(.light_theme) .agce-margin-ordty-option {\n  border-color: rgba(255, 255, 255, 0.1);\n  background: #1e2329;\n}\n\nbody:not(.light_theme) .agce-margin-ordty-option:hover {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\nbody:not(.light_theme) .agce-margin-ordty-option.is-selected {\n  border-color: #ffffff;\n}\n\nbody:not(.light_theme) .agce-margin-ordty-option-title {\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .agce-margin-ordty-option-desc {\n  color: #94a3b8;\n}\n\nbody:not(.light_theme) .agce-margin-ordty-btn-confirm {\n  background: #ffffff;\n  color: #111214;\n}\n\nbody:not(.light_theme) .agce-margin-ordty-btn-confirm:hover {\n  background: #e2e8f0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
